<template>
  <v-container>
    <!-- The pagination component to controls the pages of the table -->
    <v-items-pagination />
    <!-- A grid to show with the matching items -->
    <v-items-table />
    <!-- Another pagination component -->
    <v-items-pagination />
  </v-container>
</template>

<script>
import VItemsPagination from "./ItemsPagination";
import VItemsTable from "./ItemsTable.vue";

export default {
  components: {
    VItemsPagination,
    VItemsTable
  }
};
</script>